import { findIndex } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  solutions: {},
  volume: 0,
  open: false,
  maxVol: 1000,
  minVol: 0,
  description: "",
  inScene: true,
  onIce: null,
  chilled: false,
  frozen:false,
  onRack:false,
  roomTemp:true,
  warm:false,
  controlsVisible: false,
  mixed: false,
  renamable: false,
  showSolutionContents: false
};

export function SolutionReducer(state = { solutions: [] }, action) {
  let currentSolution;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_SOLUTION" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("solutions")){
          currentSolution = state.protocolSection.scene.apparatus.solutions[findIndex(state.protocolSection.scene.apparatus.solutions, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_SOLUTION':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("solutions")){
            protocolSection.scene.apparatus.solutions = [ ...protocolSection.scene.apparatus.solutions, newObj ]
          } else {
            protocolSection.scene.apparatus.solutions = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case 'SET_SOLUTION':
            //Payload = [id, solution]
            currentSolution.type = action.payload.type
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case "SET_SOLUTION_MIXED":
            currentSolution.mixed = action.payload.mixed;
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SOLUTION_OPEN':

            // xAPI statement
            // sendxAPI({
            //   // Type of statement
            //   verb: {
            //   description: (action.payload.open)?"opened":"closed",
            //   address: (action.payload.open)?"https://w3id.org/xapi/dod-isd/verbs/opened":"https://w3id.org/xapi/dod-isd/verbs/closed"
            //   },
            //   // Where the action occured
            //   context: currentSolution.type + " Solution",
            //   // Result of the action
            //   result: {
            //   success: true,
            //   response: action.payload.open
            //   }
            // })

            //Payload = [id, open]
            currentSolution.open = action.payload.open
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'INC_SOLUTION':
              //Payload = {id, solutions[]}

              let totalVol = 0;

              for (let i = 0; i < action.payload.solutions.length; i++) {
                const solution = action.payload.solutions[i];
                let key = Object.keys(solution)[0];
                let val = solution[Object.keys(solution)[0]];

                //Check if solution exists in this tube already - if yes = add
                if (currentSolution.solutions.hasOwnProperty(key)) {
                  currentSolution.solutions[key] += val;

                  totalVol += val;
                } else {
                  currentSolution.solutions[key] = val;

                  totalVol += val;
                }
              }

              currentSolution.volume = currentSolution.volume + totalVol;
              protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

              return { ...state, ...{
                protocolSection: protocolSection
              } }


        case 'DEC_SOLUTION':
            //Decreases volume for by volChange
            if ((currentSolution.volume - action.payload.amount) >= currentSolution.minVol) {
                for(var solution in currentSolution.solutions){
                  currentSolution.solutions[solution] = currentSolution.solutions[solution] * ((currentSolution.volume - action.payload.amount) / currentSolution.volume)
                }
                currentSolution.volume -= action.payload.amount
                //Lodash merge current pipette into solutions array
                protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution
                return { ...state, ...{
                  protocolSection: protocolSection
                } }

            } else {
                return state
            }

        case 'SET_SOLUTION_IN_SCENE':
            //Payload = [id, inScene]
            currentSolution.inScene = action.payload.inScene
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_SOLUTION_ON_RACK':
            //Payload = [id, inScene]
            currentSolution.onRack = action.payload.onRack
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_SOLUTION_HELD':
            currentSolution.held = action.payload.held
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_SOLUTION_HOMOGENIZED':
            //payload = {id, homogenized}
            currentSolution.homogenized = action.payload.homogenized
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_SOLUTION_ON_ICE':
            //Payload = [id, inScene]
            currentSolution.onIce = action.payload.onIce
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_SOLUTION_IN_FREEZER':
            //Payload = [id, inScene]
            currentSolution.inFrezeer= action.payload.inFreezer
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SET_SOLUTION_CONTROLS_VISIBLE':

            // Hide the controls for all the other pipettes
            protocolSection.scene.apparatus.solutions.forEach((solution) => {
              solution.controlsVisible = false;
            })

            // Make the current solutions controls visible
            currentSolution.controlsVisible = action.payload.controlsVisible
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'SHOW_SOLUTION_CONTENTS':

            // Hide the controls for all the other pipettes
            protocolSection.scene.apparatus.solutions.forEach((solution) => {
              solution.showSolutionContents = false;
            })

            // Make the current solutions controls visible
            currentSolution.showSolutionContents = action.payload.showSolutionContents
            protocolSection.scene.apparatus.solutions[findIndex(state.solutions, { id: action.payload.id })] = currentSolution

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case 'HIDE_ALL_CONTROLS':
          if(!protocolSection.scene.apparatus.hasOwnProperty("solutions")){
            return { ...state, ...{
              protocolSection: protocolSection
            } }
          }
            // Hide the controls for all the other pipettes
            protocolSection.scene.apparatus.solutions.forEach((solution) => {
              solution.controlsVisible = false;
            })

            protocolSection.scene.apparatus.solutions.forEach((solution) => {
              solution.showSolutionContents = false;
            })
            
            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case "UNDO":
            //Payload = {lastState}

            if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('solutions')) {

              protocolSection.scene.apparatus.solutions = action.payload.lastState.scene.apparatus.solutions

              return { ...state, ...{
                protocolSection: protocolSection
              } }

            } else {
              return state;
            }

        default:
            return state;
    }
}
